import axios from 'axios'

const marketplaceApi = axios.create({
  baseURL: 'https://aguablancaseafood.com/wp-json/wc/v3/',
  timeout: process.env.VUE_APP_ATARRAYA_TIMEOUT
})

const labelsApi = axios.create({
  baseURL: 'https://atarrayaprodapi.azure-api.net/v2/woocommerce/orders',
  timeout: process.env.VUE_APP_ATARRAYA_TIMEOUT
})

export const state = {
  orders: [],
  labels: []
}

export const getters = {
  orders: (state) => state.orders,
  labels: (state) => state.labels
}

export const mutations = {
  LOAD_ORDERS(state, data) {
    state.orders = data
  },

  LOAD_LABELS(state, data) {
    state.labels = data
  }
}

export const actions = {
  async getOrders({ commit }) {
    const response = await marketplaceApi.get('/orders', {
      params: {
        status: 'on-hold,harvested,ready-to-ship',
        consumer_key: 'ck_9bf80aa5074afa6bf3e04a560fbaa41e61ddfbd2',
        consumer_secret: 'cs_53f0e4c01ab9478d5a78e0476c2d0041a56f37f0'
      }
    })
    commit('LOAD_ORDERS', response.data)
    return response.data
  },

  async getlabels({ commit }, data) {
    const response = await labelsApi.post('/print', data, {
      responseType: 'blob'
    })
    commit('LOAD_LABELS', response.data)
    const blob = new Blob([response.data], { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)

    window.open(url, '_blank')
  }
}
